// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "能源电力工程与绿色低碳概论",
      "tec": "崔箫董香栾",
      "week": "5-12周",
      "add": "教学楼A座119信息"
    },
    {
      "sub": "操作系统",
      "tec": "姜柳",
      "week": "1-12周",
      "add": "实训楼F座402信息"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "软件工程",
      "tec": "宗鸣镝",
      "week": "1-12周",
      "add": "教学楼B座422能动"
    },
    {
      "sub": "计算机网络",
      "tec": "王楚晴",
      "week": "1-12周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "能源经济基础",
      "tec": "马铭婧",
      "week": "1-8周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "张岚",
      "week": "1-4周",
      "add": "教学楼A座117电力"
    },
    0
  ],
  "3": [
    {
      "sub": "移动终端技术",
      "tec": "李波",
      "week": "1-12周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "操作系统",
      "tec": "姜柳",
      "week": "1-12周",
      "add": "实训楼F座401信息"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "软件工程",
      "tec": "宗鸣镝",
      "week": "1-12周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "计算机网络",
      "tec": "王楚晴",
      "week": "1-12周",
      "add": "教学楼C座213教务"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "移动终端技术",
      "tec": "李波",
      "week": "1-12周",
      "add": "教学楼B座324能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "史江萍",
      "week": "1-5周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
